import { Popup } from "@dhx/ts-popup";
import { List } from "@dhx/ts-list";
import { IFormula, T_NAME, methods } from "@xbs/muon";

export default class EditPopup {
	private _suggestCallback: Function;
	private _popup: Popup;
	private _list: List;

	private _cursorStart: number;
	private _startTrim: number;

	constructor(cb: Function) {
		this._suggestCallback = cb;
	}

	isVisible() {
		return this._popup && this._popup.isVisible();
	}

	hide() {
		if (this.isVisible()) this._popup.hide();
	}

	destructor() {
		if (this._popup) this._popup.destructor();
	}

	navigate(key: "arrowDown" | "arrowUp" | "enter") {
		if (!this.isVisible()) {
			return false;
		}

		const list = this._list;
		const count = list.data.getLength();
		if (!count) return false;

		if (key === "arrowUp" || key === "arrowDown") {
			const dir = key === "arrowDown" ? 1 : -1;
			let index = list.data.getIndex(list.getFocus());
			if (typeof index === "undefined") index = dir === -1 ? count : -1;
			this._list.setFocus(list.data.getId((index + dir + count) % count));
			return true;
		}

		// enter key
		let suggest = list.getFocusItem();
		if (!suggest) {
			const id = this._list.data.getId(0);
			suggest = this._list.data.getItem(id);
		}

		this._insertSuggest(suggest.value);
		return true;
	}

	show(val: string, input: HTMLInputElement, fm: IFormula, maxHeight?: number, cursor?: number) {
		const cursorStart = cursor || input.selectionStart;
		const code = fm.code;
		const popup = this._getPopup(maxHeight);

		for (let i = 0; i < code.length; i += 3) {
			if (code[i] == T_NAME && cursorStart == code[i + 1] + code[i + 2]) {
				// cursor after name
				const check = val.substr(code[i + 1], code[i + 2]).toUpperCase();
				this._list.data.filter(item => item.value.startsWith(check));
				if (this._list.data.getLength()) {
					this._cursorStart = cursorStart;
					this._startTrim = code[i + 1];
					popup.show(input, { centering: false });
				} else {
					popup.hide();
				}
				return;
			}
		}

		// unfilter if any
		popup.hide();
	}

	private _insertSuggest(suggest: string) {
		this._suggestCallback(suggest + "(", this._startTrim, this._cursorStart, suggest.length + 1);
		this._popup.hide();
	}

	private _getPopup(maxHeight: number) {
		if (!this._popup) {
			const data = Object.keys(methods).map(i => ({ value: i }));

			this._popup = new Popup({
				css: "dhx_suggest_list",
			});
			this._list = new List(null);
			this._list.data.parse(data);
			this._list.events.on("Click", id => {
				const suggest = this._list.selection.getItem() as any;
				this._insertSuggest(suggest.value);
				this._list.selection.remove(suggest.id);
			});

			this._popup.attach(this._list);
		}
		const popup = this._popup.getRootNode();
		if (!popup.style.maxHeight && maxHeight) {
			popup.style.maxHeight = `${maxHeight}px`;
		}
		return this._popup;
	}
}
